import { render, staticRenderFns } from "./properties-block-map.vue?vue&type=template&id=09d1a9ec&scoped=true"
import script from "./properties-block-map.vue?vue&type=script&lang=js"
export * from "./properties-block-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1a9ec",
  null
  
)

export default component.exports